/**
 * @Author: Zewei
 * @Date:   2018-02-13T14:14:58+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T17:35:51+08:00
 */

import React, { Component } from 'react';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchUserGroupList, createUserGroupList, deleteUserGroupList, fetchUserGroupDetail, updateUserGroupList, emptyUserGroupDetail } from '../../actions/daily-report-actions.js';
import { fetchUserInit } from '../../actions/system-setting-actions.js';
import { fetchEmployeesList, fetchAllEmployees } from '../../actions/employee-management-actions.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
import { Table, Button, Divider, Modal, Input, Icon, TreeSelect } from 'antd';
import UserGroupModal2 from '../../components/DailyReport/UserGroupModal2.js';
import debounce from 'lodash.debounce';

// const fetchInitUserListFlag = false;
const { confirm } = Modal;
const { TreeNode } = TreeSelect;
const mapStateToProps = state => {
    return {
        dailyReports: state.dailyReports,
        systemSetting: state.systemSetting,
        employeeManagement: state.employeeManagement,
        departmentStructure: state.departmentStructure,
    }
}
const mapDispatchToProps = {
    fetchUserGroupList, createUserGroupList, deleteUserGroupList, fetchUserGroupDetail, updateUserGroupList, emptyUserGroupDetail,
    fetchEmployeesList, fetchAllEmployees, fetchUserInit, fetchDepartmentsList
};

@connect(mapStateToProps, mapDispatchToProps)

class UserGroup2 extends Component {
    constructor(props) {
        super(props)
        this.columns = [{
            title: '群组名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '部门',
            dataIndex: 'department_name',
            key: 'department_name',
        }, {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <span>
                    {this.props.access.userGroup2.u_value && <Button icon="edit" size="small" onClick={this.handleEdit.bind(this, record.id)} >编辑</Button>}
                    {this.props.access.userGroup2.d_value && <Button icon="usergroup-delete" size="small" onClick={this.handleDelete.bind(this, record.id)} >删除</Button>}
                </span>
            ),
        }];
        // 使用 debounce 函数来节流 以 避免 onchange事件的频繁触发 导致页面的频繁重绘
        this.fetchUserList = debounce(this.fetchUserList, 800);
    }

    state = {
        userGroupModalVisible: false,
        editModalVisible: false,
        filter: {
            page: 1
        }
    }

    componentDidMount() {
        this._fetchUserGroupList(this.state.filter)
        this._fetchUserInit()
        this._fetchDepartmentsList()
        this.fetchUserList()
    }
    _fetchUserGroupList = (params) => {
        this.props.fetchUserGroupList(params)
    }
    fetchUserList = (params) => {
        this.props.fetchEmployeesList(params)
    }
    _fetchUserInit = () => {
        this.props.fetchUserInit()
    }
    _fetchDepartmentsList = () => {
        this.props.fetchDepartmentsList()
    }

    handleEdit = (id) => {
        let params = { modelId: id };
        this.props.fetchUserGroupDetail(params)
        this.showModal('editModalVisible')
    }

    handleDelete = (id) => {
        confirm({
            title: '确定删除?',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                let params = { id };
                this.props.deleteUserGroupList(params);
            },
            onCancel: () => { }
        })
    }


    handleGoBack = () => {
        window.history.back()
    }

    handleCreateNew = () => {
        this.showModal('userGroupModalVisible')
    }

    handleModalCancel = (para) => {
        this.setState({
            [para]: false,
        })
        para === 'editModalVisible' && this.props.emptyUserGroupDetail()
    }

    showModal = (para) => {
        this.setState({
            [para]: true
        })
    }

    handleSearchChange = (v) => {
        let params = { real_name: v };
        this.fetchUserList(params)
    }


    handleSelectChange = (v) => {
        this.setState({
            groupUser: v
        })
    }

    createGroupList = (data) => {
        const { name, groupUser } = this.state;
        if (name && groupUser) {
            let payload = {
                name,
                employee_ids: groupUser.map(i => i),
                department_id: this.state.department_id
            }
            this.props.createUserGroupList(payload)
            this.handleModalCancel('userGroupModalVisible')
        } else {
            return
        }
    }

    updateGroupList = (data) => {
        // const { name, department_id, groupUser, reportType } = this.state;
        const { groupListDetail } = this.props.dailyReports;
        const state = this.state;
        let payload = {
            name: state.name ? state.name : groupListDetail.name,
            employee_ids: state.groupUser ? state.groupUser.map(i => i) : groupListDetail.group_members,
            id: groupListDetail.id,
            department_id: state.department_id ? state.department_id : groupListDetail.department_id
        }
        this.props.updateUserGroupList(payload)

        this.handleModalCancel('editModalVisible')
    }

    _emptyUserGroupState = () => {
        this.setState({
            name: null,
            department_id: null,
            groupUser: null,
            reportType: null,
        })
    }

    handleUserGroupNameChange = (e) => {
        this.setState({
            name: e.target.value
        })
    }

    handleUserGroupDepartmentChange = (val) => {
        this.setState({
            department_id: val
        })
    }

    handleReportTypeSelectChange = (v) => {
        this.setState({
            reportType: parseInt(v, 10)
        })
    }

    componentWillReceiveProps(nextProps) {
        const { actionStatus } = nextProps.dailyReports;
        // actionStatus && this._fetchUserGroupList()
        if (actionStatus) {
            this._fetchUserGroupList(this.state.filter)
            this._emptyUserGroupState()
        }
    }

    setGroupFilter = value => {
        var filter = {
            ...this.state.filter,
            name: value
        }
        this.setState({
            filter:  filter

        })
        this.props.fetchUserGroupList(filter)
    }
    setDepartmentFilter = value => {
        var filter = {
            ...this.state.filter,
            department_id: value
        }
        this.setState({
            filter: filter

        })
        this.props.fetchUserGroupList(filter)
    }
    renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode value={item.id + ""} title={item.name} key={item.id} dataRef={item}>
                        {item.children.length !== 0 && this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            // delete item.children
            return <TreeNode key={item.id} title={item.name} value={item.id + ""} {...item} />;
        });
    }
    render() {
        const { userGroupModalVisible, editModalVisible } = this.state;
        const { userGroupList, groupListDetail } = this.props.dailyReports;
        console.log(groupListDetail)
        const { initUser } = this.props.systemSetting;
        const { employeeList, fetching } = this.props.employeeManagement;
        const { departmentsList } = this.props.departmentStructure;

        let employeeListData = employeeList ? employeeList.Data : [],
            paginationCfg;
        if (userGroupList) {
            paginationCfg = {
                current: userGroupList.Page,
                total: userGroupList.Total,
                pageSize: userGroupList.PageSize,
                onChange: (page) => {
                    var filter = {
                        ...this.state.filter,
                        page: page
                    }
                    this.setState({
                        filter: {
                            ...this.state.filter,
                            page: page
                        }
                    })
                    this._fetchUserGroupList(filter)
                }
            }
        }

        return (
            <div className="app-module-item">
                <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
                    {this.props.access.userGroup2.c_value && <Button icon="plus" type="primary" onClick={this.handleCreateNew}>新建群组</Button>}
                </div>
                <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
                    <TreeSelect placeholder="请选择部门"
                        style={{ width: 250 }}
                        allowClear
                        showSearch={false}
                        autoExpandParent={true}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeDefaultExpandAll
                        onChange={this.setDepartmentFilter}>
                        {departmentsList &&
                            this.renderTreeNodes(departmentsList)}
                    </TreeSelect>
                </div>
                <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
                    <Input.Search
                        placeholder="名称"
                        onSearch={this.setGroupFilter}
                        style={{ width: 200 }}
                        enterButton />
                </div>
                <div style={{ clear: "both" }}></div>
                <div>
                    {
                        userGroupList ?
                            <Table
                                // rowSelection={this.rowSelection}
                                dataSource={userGroupList.Data}
                                pagination={paginationCfg}
                                columns={this.columns}
                                rowKey={record => record.id}
                            />
                            :
                            ''
                    }
                </div>
                {/* 新建群组 modal 弹窗 */}
                {
                    (initUser && departmentsList) ?
                        <UserGroupModal2
                            userList={employeeListData}
                            initUser={initUser}
                            fetching={fetching}
                            departmentsList={departmentsList}
                            modalVisible={userGroupModalVisible}
                            handleModalCancel={this.handleModalCancel.bind(this, 'userGroupModalVisible')}
                            createGroupList={this.createGroupList}
                            handleUserGroupNameChange={this.handleUserGroupNameChange}
                            handleSelectChange={this.handleSelectChange}
                            handleUserGroupDepartmentChange={this.handleUserGroupDepartmentChange}
                            onSearchChange={this.handleSearchChange}
                            handleReportTypeSelectChange={this.handleReportTypeSelectChange}
                        />
                        :
                        ''
                }
                {/* 编辑群组 modal 弹窗 */}
                {
                    (initUser && groupListDetail && departmentsList) ?
                        <UserGroupModal2
                            userList={employeeListData}
                            initUser={initUser}
                            departmentsList={departmentsList}
                            groupListDetail={groupListDetail}
                            modalVisible={editModalVisible}
                            handleModalCancel={this.handleModalCancel.bind(this, 'editModalVisible')}
                            handleSelectChange={this.handleSelectChange}
                            updateGroupList={this.updateGroupList}
                            handleUserGroupNameChange={this.handleUserGroupNameChange}
                            onSearchChange={this.handleSearchChange}
                            handleUserGroupDepartmentChange={this.handleUserGroupDepartmentChange}
                        />
                        :
                        ''
                }
            </div>
        )
    }
}

UserGroup2 = LayoutWrapper(UserGroup2);
export default UserGroup2;



// WEBPACK FOOTER //
// ./src/routes/DailyReport/UserGroup2.js